import { Button, Icon } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import Grid from '@material-ui/core/Grid';
import React, { useEffect, useState } from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useParams } from 'react-router-dom';
import { toastr } from '../_components/toastr';
import { history } from '../_helpers/history';
import { userLocationService } from '../_services';
import { useDrawerStyles } from '../_styles';

export function LocationEdit({ successCallback }) {

    const [isLoading, setLoading] = useState(false);
    const [location, setLocation] = useState({ name: '', email: '', password: '', role: '', department: '' });
    const [receiveNotificationEmails, setReceiveNotificationEmails] = useState(true);
    const classes = useDrawerStyles();
    const { locationId } = useParams();

    function navigateBack() {
        history.push('/Locations');
    };

    useEffect(() => { fetchData() }, []);

    function fetchData() {
        return userLocationService.get(locationId)
            .then(data => {
                data.role = data.roles;
                setReceiveNotificationEmails(data.receiveNotificationEmails);
                setLocation(data);
            });
    }

    function submit(e) {
        e.preventDefault();
        setLoading(true);

        var _location = location;
        _location.roles = [location.role];
        _location.receiveNotificationEmails = receiveNotificationEmails;
        userLocationService
            .put(locationId, location)
            .then(
                (d) => { console.log(d); successCallback(); navigateBack(); },
                (e) => { console.log(e); setLoading(false); toastr.error("Something went wrong. Please try again later") }
            );
    }

    function confirmRegistration(e) {
        e.preventDefault();
        setLoading(true);
        userLocationService
            .confirmLocation(locationId)
            .then(
                (d) => { console.log(d); successCallback(); navigateBack(); },
                (e) => { console.log(e); setLoading(false); toastr.error("Something went wrong. Please try again later") }
            );
    }

    function disable(e) {
        e.preventDefault();
        setLoading(true);
        userLocationService
            .disable(locationId)
            .then(
                (d) => { console.log(d); successCallback(); navigateBack(); },
                (e) => { console.log(e); setLoading(false); toastr.error("Something went wrong. Please try again later") }
            );
    }

    function handleChange(event) {
        var _location = location;
        _location[event.target.name] = event.target.value;
        setLocation({ ..._location });
    };

    function handleReceiveNotificationsChange() {
        setReceiveNotificationEmails(prev => !prev);
    }

    return (
        <>
            <Drawer anchor="right" open={true} onClose={navigateBack} variant="temporary">

                <div
                    tabIndex={0}
                    className={classes.drawer}
                    role="button">
                    <div className="padding-sm">

                        <div className={classes.heading}>
                            <h4>
                                {!location.registrationConfirmed && <span>Confirm Location</span>}
                                {location.registrationConfirmed && <span>Update Location</span>}
                                <Icon className={classes.closeButton} onClick={navigateBack}>
                                    close
                                </Icon>
                            </h4>
                        </div>

                        <ValidatorForm className={classes.form} onSubmit={submit} noValidate autocomplete="off">
                            <TextValidator
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                label="Location Name"
                                autoComplete='off'
                                name="name"
                                value={location.name}
                                disabled={isLoading}
                                onChange={handleChange}
                                validators={['required']}
                                errorMessages={['This field is required']}
                                autoFocus
                            />

                            <Grid container spacing={0}>
                                <Grid container item spacing={0} xs={location.isActive === false ? 12 : 6}>
                                    <Button
                                        type="submit"
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        disabled={isLoading}
                                        disableElevation
                                        className={classes.submit}
                                        onClick={location.registrationConfirmed === true ? submit : confirmRegistration}
                                    >
                                        {location.registrationConfirmed && <><Icon>check</Icon> {location.isActive === false ? <>Save and Reactivate</> : <>Save</>}</>}
                                        {!location.registrationConfirmed && <><Icon>check</Icon>Confirm Registration</>}
                                    </Button>
                                </Grid>
                                {(location.isActive === true) &&
                                    <Grid container item spacing={0} xs={6}>
                                        <Button
                                            type="button"
                                            fullWidth
                                            variant="contained"
                                            color="secondary"
                                            disabled={isLoading}
                                            disableElevation
                                            className={classes.submit}
                                            onClick={location.registrationConfirmed === true ? disable : navigateBack}
                                        >
                                            {location.registrationConfirmed && <><Icon>remove</Icon> Disable</>}
                                            {!location.registrationConfirmed && <><Icon>close</Icon>Cancel</>}
                                        </Button>
                                    </Grid>
                                }
                            </Grid>
                        </ValidatorForm>
                    </div>
                </div>
            </Drawer>
        </>
    );
}